import { Button, Sizes } from '@sede-enterprise/shell-ds-react-framework';
import { AuthenticationScheme } from '@see-power-pft-common-js/auth/enums';
import { useAuth } from 'common-react/auth/AuthProvider';
import {
  FormGroupContainer,
  IntroContainer,
  LoginContentsContainer,
  WelcomeContents,
  WelcomeSubTextContainer,
  WelcomeTitleTextContainer,
} from 'pages/Intro/IntroPageContent/IntroPageContent.styled';

export const IntroPageContent = ({ isMobile }: { isMobile: boolean }) => {
  const { logins } = useAuth();

  const loginCount = Object.keys(logins).length;

  return (
    <LoginContentsContainer isMobile={isMobile}>
      <WelcomeContents>
        <WelcomeTitleTextContainer isMobile={isMobile}>
          Welcome to the Shell Battery Management Hub
        </WelcomeTitleTextContainer>
        <WelcomeSubTextContainer isMobile={isMobile}>
          Please sign in to continue
        </WelcomeSubTextContainer>
        <IntroContainer>
          <FormGroupContainer>
            {logins[AuthenticationScheme.DEV] ? (
              <Button
                style={{
                  margin: '0 auto',
                  width: loginCount === 1 ? '360px' : '',
                  minWidth: '180px',
                }}
                onClick={logins[AuthenticationScheme.DEV]}
                fullWidth={loginCount === 1}
                size={Sizes.Large}
              >
                {AuthenticationScheme.DEV}
              </Button>
            ) : (
              <></>
            )}
            {logins[AuthenticationScheme.CIPM3] ? (
              <Button
                style={{
                  margin: '0 auto',
                  width: loginCount === 1 ? '360px' : '',
                  minWidth: '180px',
                }}
                onClick={logins[AuthenticationScheme.CIPM3]}
                fullWidth={loginCount === 1}
                size={Sizes.Large}
              >
                Customer Login
              </Button>
            ) : (
              <></>
            )}
            {logins[AuthenticationScheme.CIPM4] ? (
              <Button
                style={{
                  margin: '0 auto',
                  width: loginCount === 1 ? '360px' : '',
                  minWidth: '180px',
                }}
                onClick={logins[AuthenticationScheme.CIPM4]}
                fullWidth={loginCount === 1}
                size={Sizes.Large}
              >
                Customer Login
              </Button>
            ) : (
              <></>
            )}
            {logins[AuthenticationScheme.DEPSSO] ? (
              <Button
                style={{
                  margin: '0 auto',
                  width: loginCount === 1 ? '360px' : '',
                  minWidth: '180px',
                }}
                onClick={logins[AuthenticationScheme.DEPSSO]}
                fullWidth={loginCount === 1}
                size={Sizes.Large}
              >
                Shell Staff login
              </Button>
            ) : (
              <></>
            )}
          </FormGroupContainer>
        </IntroContainer>
      </WelcomeContents>
    </LoginContentsContainer>
  );
};
